
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> ニュース管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" color="info"><a href="news/form">新規作成</a></CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="news"
                :fields="fields"
                itemsPerPage="30"
                pagination
                :tableFilter="true"
                @update:table-filter-value="search"
                sorter
                @update:sorter-value="sort"
              >
                <template #title="{item}">
                  <td>
                    <CLink :href="'/news/' + item.id" > {{ item.title }}</CLink>
                  </td>
                </template>
                <template #description="{item}">
                  <td>
                    {{ item.description.slice(0, 40) }}...
                  </td>
                </template>

                <template #created_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #updated_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm"><a :href='"news/" + item.id + "/form"'>編集</a></CButton>
                    <CButton color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>

                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>


              </CDataTable>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteNews()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
//TODO: ぱんくず

import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {
    Paginate
  },
  data() {
    return {
      news: [],
      fields: [
        { key: 'id', label: ""},
        { key: 'title', label: "ニュースタイトル"},
        { key: 'description', label: "内容"},
        { key: 'created_at', label: "作成日"},
        { key: 'show_details',  label: '',  _style: 'width:15%', sorter: false, filter: false}],
      recordModal: false,
      deleteModal: false,
      industries: {},
      mode: "",
      username: '',
      password: '',
      itemIndex: 0,
      record_id: this.$route.params.id,
      page: 1,
      word: "",
      meta: {},
      record: {
        name: "",
        description: ""
      },
      stateDic: {
        'public': '公開中',
        'private': '非公開',
        'draft': '下書き'
      },
    }
  },
  validations: {
    record: {
      name: {required},
      description: {required}
    }
  },
  methods: {
    stateColor: function(e) {
      if(e == "public") {
        return 'success'
      } else if(e == "private") {
        return 'warning'
      } else {
        return 'dark'
      }
    },
    sort: function(e) {
      this.sort_column = e.column
      this.sort_asc = (e.asc == true)? "asc" : "desc"
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/news?word=" + this.word + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.news = response.data.news
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    updatePageData: function(n, e) {
      this.page = n
      console.log(e)
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/news?page=" + n + "&word=" + this.word + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.news = response.data.news
          this.meta = response.data.meta
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    search: function(e) {
      this.word = e
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/news?word=" + this.word + "&page=" + this.page, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.news = response.data.news
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    login () {
      this.$cognito.login(this.username, this.password)
        .then(result => {
          console.log(result)
          this.$router.replace('/home')
        })
        .then(err => {
          this.error = err
        })
    },
    showDeleteModal: function(p, i) {
      this.deleteModal = true
      this.record = p
      this.itemIndex = i
    },
    deleteNews: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/news/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.news.splice(this.itemIndex, 1)
        }).catch(error => {
          console.log(error)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/news?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.items = response.data.industries
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    formatDate: function(d) {
      return moment(d).format("YYYY/MM/DD HH:mm")
    },
    validator (val) {
      return val ? val.length >= 1 : false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/news/" + this.record.id)
        .then(() => {
          this.items.splice(this.itemIndex, 1)
          this.hideDeleteModal()
        }).catch(error => {
          this.errorNotify(error.response)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/news", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.news = response.data.news
          this.meta = response.data.meta
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
    computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
